import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuth } from '../context/useAuth';

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="route-splash" role="status" aria-live="polite">
        <span className="spinner" aria-hidden="true" />
        <p>Restoring your session…</p>
      </div>
    );
  }

  if (!user) {
    const returnUrl = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?ReturnUrl=${returnUrl}`} replace />;
  }

  return <>{children}</>;
}
